import { render } from "./TaskGroupCategoriesList.vue?vue&type=template&id=24607c9f&scoped=true"
import script from "./TaskGroupCategoriesList.vue?vue&type=script&lang=js"
export * from "./TaskGroupCategoriesList.vue?vue&type=script&lang=js"

import "./TaskGroupCategoriesList.vue?vue&type=style&index=0&id=24607c9f&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24607c9f"]])

export default __exports__